import { theme } from "../Theme";
import React from "react";
import { ThemeProvider } from "@material-ui/styles";
import HeaderBar from "../components/shared/BasePage/HeaderBar";
import { SnackbarProvider } from "notistack";
import FooterArea from "../components/shared/BasePage/FooterArea";
import HelpBar from "../components/shared/BasePage/HelpBar";
import Routes from "../routes/index";

const Layout: React.FC = () => {
    return (
        <ThemeProvider theme={theme}>
            <SnackbarProvider maxSnack={4}>
                <HeaderBar />
                <Routes />
                <HelpBar />
                <FooterArea />
            </SnackbarProvider>
        </ThemeProvider>
    );
};

export default Layout;
